import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardHeader,
  FileInput,
  FileInputExtendedProps,
  Form,
  FormField,
  Select,
  Text,
  TextInput,
} from "grommet";
import { useNavigate } from "react-router-dom";
import "./ResetPassword.css";
import { MedicalEmergencyHelper } from "../../../../../../util/medical-emergency/MedicalEmergencyHelper";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from 'mobx-react';
import { FormView, Hide } from "grommet-icons";
import { Mixpanel } from "../../../../../../util/Helper";
import visible from '../../../../../../assets/visible.png';
import hide from '../../../../../../assets/hide.png';
import SuccessModal from "./SuccessModal/SuccessModal";



const ResetPassword = observer(() => {

  const { rootStore } = useStore();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [buttonEnable, setButtonEnable] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const submit = () => {

    let uInfos = localStorage.getItem("userinfo");
    if(uInfos)
      {
    const userinformation = JSON.parse(uInfos);
    Mixpanel.track("web_reset_password_click",userinformation.username);
      }

  
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(.{9,})$/;
    if (!rootStore.emsStore.getPassword) {
      rootStore.emsStore.handleResetPassError("( Please enter your new password )");
      rootStore.emsStore.handleErrorTxt("password");
      return;
    }
    if (!passwordRegex.test(rootStore.emsStore.getPassword)) {
      rootStore.emsStore.handleResetPassError("( Password must be greater then 8 characters and include lowercase, uppercase, special characters, and numbers. )");
      rootStore.emsStore.handleErrorTxt("fail");
      return;
    }
    if (!rootStore.emsStore.getConfirmPassword) {
      rootStore.emsStore.handleResetPassError("( Please enter your confirm password )");
      rootStore.emsStore.handleErrorTxt("confirmpassword");
      return;
    }
    if (rootStore.emsStore.getPassword != rootStore.emsStore.getConfirmPassword) {
      rootStore.emsStore.handleResetPassError("( password and confirm password not match )");
      rootStore.emsStore.handleErrorTxt("notmatch");
      return;
    }
    MedicalEmergencyHelper.resetPassword(rootStore.emsStore.getPassword);
    rootStore.emsStore.handleErrorTxt("success");
    rootStore.emsStore.handleIsPassReset("Reset Password Successfully.");
    {
      rootStore.emsStore.getErrorTxt != "success"
      &&
      setTimeout(() => {
        rootStore.emsStore.handleErrorTxt("");
        rootStore.emsStore.handleIsPassReset("");
      }, 3000);
    }
    rootStore.emsStore.handlePassword("");
    rootStore.emsStore.handleConfirmPassword("");
  };

  const confirm = (value: any) => {
    if (rootStore.emsStore.getResetPassError) {
      rootStore.emsStore.handleResetPassError("");
    }
    if (rootStore.emsStore.getIsPassReset) {
      rootStore.emsStore.handleIsPassReset("");
    }
    if (rootStore.emsStore.getErrorTxt == "confirmpassword" || rootStore.emsStore.getErrorTxt == "notmatch") {
      rootStore.emsStore.handleErrorTxt("");
    }
    rootStore.emsStore.handleConfirmPassword(value);
  }

  const newPass = (value: any) => {
    if (rootStore.emsStore.getResetPassError) {
      rootStore.emsStore.handleResetPassError("");
    }
    if (rootStore.emsStore.getIsPassReset) {
      rootStore.emsStore.handleIsPassReset("");
    }
    if (rootStore.emsStore.getErrorTxt == "password" || rootStore.emsStore.getErrorTxt == "fail") {
      rootStore.emsStore.handleErrorTxt("");
    }
    const Regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(.{9,})$/;
    if (value && Regex.test(value)) {
      rootStore.emsStore.handleSubmitBtnEnable(true);
    } else {
      rootStore.emsStore.handleSubmitBtnEnable(false);
    }
    rootStore.emsStore.handlePassword(value);
  }

  const passwordVisibilityToggle = (isPwdVisible: boolean) => {

    let uInfos = localStorage.getItem("userinfo");
   
    
    rootStore.emsStore.handlePassWordVisiblity(isPwdVisible);
    if(uInfos)
      {
        const userinformation = JSON.parse(uInfos);
    Mixpanel.track("web_toggle_password_visibility", {
      isPasswordVisible: isPwdVisible,
      name:userinformation.username
   
    })
  }
  }

  const cPasswordVisibilityToggle = (isPwdVisible: boolean) => {
    rootStore.emsStore.handleCPassWordVisiblity(isPwdVisible);
    let uInfos = localStorage.getItem("userinfo");
    if(uInfos)
      {
const userinformation = JSON.parse(uInfos);

    Mixpanel.track("web_toggle_confirm_password_visibility", {
      isPasswordVisible: isPwdVisible,
      name:userinformation.username
    })
  }
  }


  return (
    <Box className="reset_pass_main_container">
      <SuccessModal successMsg={rootStore.emsStore.getErrorTxt} />
      <Card>
        <Text className="page-heading">Reset Password</Text>
        <Form
          validate="change"
          className="create-user-form"
        >
        <Box>
          <FormField name="password1" htmlFor="textinput" label="New Password" className="label">
            <Box className="pwdMain">
              <TextInput
                placeholder="Enter here"
                id="textinput"
                name="password1"
                type={rootStore.emsStore.getPwdVisiblity ? "text" : "password"}
                value={rootStore.emsStore.getPassword}
                onChange={(event) => newPass(event.target.value)}
                className={rootStore.emsStore.getErrorTxt == "password" || rootStore.emsStore.getErrorTxt == "fail" ? "input error-class" : "input"}
              />
              <Box className="showHideIcons">
                {
                  rootStore.emsStore.getPwdVisiblity
                    ?
                    <Text onClick={() => passwordVisibilityToggle(false)}><img src={hide} /></Text>
                    :
                    <Text onClick={() => passwordVisibilityToggle(true)}><img src={visible} /></Text>
                }
              </Box>
            </Box>
          </FormField>
          {
            !rootStore.emsStore.getSubmitBtnEnable
              &&
            <span className="password-instruction" style={{ display: !rootStore.emsStore.getPassword ? 'none' : 'block', color: rootStore.emsStore.getSubmitBtnEnable ? '#34d147' : '#E46969' }}>**Password must be greater then 8 characters and include lowercase, uppercase, special characters, and numbers.**</span>
          }
          {
            rootStore.emsStore.getErrorTxt == "password"
              &&
            <span className="password-instruction" style={{color: '#E46969' }}>**Enter Password**</span>
          }
   
          <FormField name="password" htmlFor="textinput-id" label="Confirm New Password" className="label mt-30">
            <Box className="pwdMain">
              <TextInput
                placeholder="Enter here"
                id="textinput-id"
                name="password"
                type={rootStore.emsStore.getCPwdVisiblity ? "text" : "password"}
                value={rootStore.emsStore.getConfirmPassword}
                onChange={(event) => confirm(event.target.value)}
                className={rootStore.emsStore.getErrorTxt == "confirmpassword" || rootStore.emsStore.getErrorTxt == "notmatch" ? "input error-class" : "input"}
              />
              <Box className="showHideIcons">
                {
                  rootStore.emsStore.getCPwdVisiblity
                    ?
                    <Text onClick={() => cPasswordVisibilityToggle(false)}><img src={hide} /></Text>
                    :
                    <Text onClick={() => cPasswordVisibilityToggle(true)}><img src={visible} /></Text>
                }
              </Box>
            </Box>
          </FormField>
            {
                rootStore.emsStore.getErrorTxt == "confirmpassword"
                  &&
                <span className="password-instruction" style={{color: '#E46969' }}>**Enter confirm password**</span>
            }
            {
            rootStore.emsStore.getErrorTxt == "notmatch"
              &&
            <span className="password-instruction" style={{color: '#E46969' }}>**Both the passwords do not match**</span>
            }
            {/* {
            rootStore.emsStore.getErrorTxt == "success"
              &&
            <span className="password-instruction" style={{color: '#34d147' }}>**Password changed successfully**</span>
            } */}
        </Box>
        <div style={{ 
          marginTop: '16px',
          padding: '12px',
          backgroundColor: '#f8f9fa',
          borderRadius: '4px',
          fontSize: '12px',
          color: '#555',
          width: '600px'
        }}>
          <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Password minimum length</div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
            <span style={{marginLeft: '4px' }}>8 character(s)</span>
          </div>
          <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Password requirements</div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
            <span>• Contains at least 1 lowercase letter</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
            <span>• Contains at least 1 uppercase letter</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
            <span>• Contains at least 1 special character</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>• Contains at least 1 number</span>
          </div>
        </div>
        {/* <span style={{ display: !rootStore.emsStore.getResetPassError ? 'none' : 'block', color: 'red', fontSize: 20 }}>{rootStore.emsStore.getResetPassError}</span>
        <span style={{ display: !rootStore.emsStore.getIsPassReset ? 'none' : 'block', color: 'green', fontSize: 20 }}>{rootStore.emsStore.getIsPassReset}</span> */}
            <Button className="submit-button" type="submit" onClick={submit} label="Submit" color={"brand-1"} style={{position: "absolute",left:"20px",bottom:'13%'}}/>
        </Form>
      </Card>
    </Box>
  );
});

export default ResetPassword;
